/**
 * Aviso de que hay una versión nueva de la app instalada y esperando.
 *
 * El registro del service worker corre en `index.js`, fuera del árbol de
 * React: tiene que engancharse desde el arranque, antes de que exista ninguna
 * pantalla. Este módulo es el puente hacia el cartel que ofrece "Actualizar",
 * mismo patrón que `offline/instalacion.js`, sin acoplar React al registro del
 * service worker.
 *
 * **Por qué no se recarga sola.** El service worker nuevo ya se activó solo
 * (`skipWaiting` + `clients.claim` en `sw.js`) — lo que falta acá es sólo la
 * recarga de la página para que el bundle que ya está corriendo en memoria se
 * reemplace por el nuevo. Una recarga forzada en medio de un formulario le
 * borra a alguien lo que venía cargando en la obra, así que se ofrece el botón
 * y la persona decide cuándo.
 */

let activarPendiente = null;
const suscriptores = new Set();

function notificar() {
  for (const fn of suscriptores) {
    try { fn(); } catch { /* un suscriptor roto no puede frenar al resto */ }
  }
}

/** Avisa a la UI cuando hay (o deja de haber) una actualización esperando. */
export function suscribirse(fn) {
  suscriptores.add(fn);
  return () => suscriptores.delete(fn);
}

/** True si hay una versión nueva instalada, esperando que alguien la active. */
export function hayActualizacionPendiente() {
  return activarPendiente !== null;
}

/** Activa la versión nueva y recarga: recién ahí se ve el cambio. */
export function activarActualizacion() {
  if (!activarPendiente) return;
  activarPendiente();
  window.location.reload();
}

/** Llamado desde `registrarSW.js` cuando ya hay una versión nueva instalada. */
export function avisarActualizacionDisponible(activar) {
  activarPendiente = activar;
  notificar();
}
